import { render, staticRenderFns } from "./CreateReferralUnit.vue?vue&type=template&id=b972d99a&scoped=true"
import script from "./CreateReferralUnit.vue?vue&type=script&lang=js"
export * from "./CreateReferralUnit.vue?vue&type=script&lang=js"
import style0 from "./CreateReferralUnit.vue?vue&type=style&index=0&id=b972d99a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b972d99a",
  null
  
)

export default component.exports